import {
  ImagesType,
  ImagesTypeEnum,
} from '../../components/common/imagesField/ImagesField';
import { TicketsBundle } from '../../components/common/ticketsBoundles';
import { ExtraTicketsRequest } from '../../types/freeTickets';
import { TicketDiscount, TicketRatesDiscount } from '../../types/property';

export const SET_LONGITUDE = 'SET_LONGITUDE';
export const SET_LATITUDE = 'SET_LATITUDE';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_MARK = 'SET_MARK';
export const REMOVE_MARK = 'REMOVE_MARK';
export const SET_TRESHOLD_DISCOUNT = 'SET_TRESHOLD_DISCOUNT';
export const SET_DISCOUNT = 'SET_DISCOUNT';
export const SET_GALLERY_FILES_MOBILE = 'SET_GALLERY_FILES_MOBILE';
export const SET_GALLERY_FILES = 'SETG_GALLERY_FILES';
export const SET_EMAIL_GALLERY_FILE = 'SET_EMAIL_GALLERY_FILE';
export const SET_FREE_TICKETS = 'SET_FREE_TICKETS';
export const SET_OTHER_LANDING_DATA = 'SET_OTHER_LANDING_DATA';
export const SET_TICKETS_BUNDLES = 'SET_TICKETS_BUNDLES';

export const changeLongitude = (data: number) => ({
  type: SET_LONGITUDE,
  payload: data,
});

export const changeLatitude = (data: number) => ({
  type: SET_LATITUDE,
  payload: data,
});

export const changeAddress = (data: string) => ({
  type: SET_ADDRESS,
  payload: data,
});

export const setMark = () => ({
  type: SET_MARK,
  payload: null,
});

export const removeMark = () => ({
  type: REMOVE_MARK,
  payload: null,
});

export const setTresholdDiscount = (data: Array<TicketRatesDiscount>) => ({
  type: SET_TRESHOLD_DISCOUNT,
  payload: data,
});

export const setDiscount = (data: TicketDiscount) => ({
  type: SET_DISCOUNT,
  payload: data,
});

export const setGalleryFiles = (
  data: Array<File>,
  imagesType: ImagesTypeEnum = ImagesTypeEnum.DESKTOP
) => ({
  type:
    imagesType === ImagesTypeEnum.DESKTOP
      ? SET_GALLERY_FILES
      : SET_GALLERY_FILES_MOBILE,
  payload: data,
});
export const setEmailGalleryFile = (file?: File | string) => ({
  type: SET_EMAIL_GALLERY_FILE,
  payload: file,
});
export const setFreeTickets = (data: ExtraTicketsRequest) => ({
  type: SET_FREE_TICKETS,
  payload: data,
});
export const setOtherLandingData = (data: any) => ({
  type: SET_OTHER_LANDING_DATA,
  payload: data,
});

export const setTicketsBundles = (data: {
  bundleTickets: Array<TicketsBundle>;
}) => ({
  type: SET_TICKETS_BUNDLES,
  payload: data,
});
